'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFields = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Form = require('../../Presentational components/Form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reduxForm = require('redux-form');

var _util = require('@its/util');

var _regexp = require('@its/util/lib/regexp');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Required = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'REQUIRED',
  description: 'Notify that a field is required',
  defaultMessage: 'Required'
});

var NumberExpected = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'EXPECTED_NUMBER',
  description: 'Notify that a number is requested for that filed',
  defaultMessage: 'A number is expected'
});

var MaxLength = function MaxLength(maxLength) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'MAX_LENGTH',
    description: 'Notify that a number is requested for that filed',
    defaultMessage: 'Max length will be {maxLength}',
    values: { maxLength: maxLength }
  });
};

var MinLength = function MinLength(minLength) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'MIN_LENGTH',
    description: 'Notify that a number is requested for that filed',
    defaultMessage: 'Min length will be {minLength}',
    values: { minLength: minLength }
  });
};

var MaxAndMinLength = function MaxAndMinLength(maxLength, minLength) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'MAX_AND_MIN_LENGTH',
    description: 'Notify that a number is requested for that filed',
    defaultMessage: 'Max length will be {maxLength} and Min length will be {minLength}',
    values: { maxLength: maxLength, minLength: minLength }
  });
};

var Max = function Max(value) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'MAX_VALUE',
    description: 'Notify min value',
    defaultMessage: 'Max value will be {value}',
    values: { value: value }
  });
};

var Min = function Min(value) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'MIN_VALUE',
    description: 'Notify max value',
    defaultMessage: 'Min value will be {value}',
    values: { value: value }
  });
};

var MaxAndMin = function MaxAndMin(maxValue, minValue) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'MAX_AND_MIN_VALUE',
    description: 'Notify max and min value',
    defaultMessage: 'Max value will be {maxValue} and Min value will be {minValue}',
    values: { maxValue: maxValue, minValue: minValue }
  });
};

var getFields = exports.getFields = function getFields(groups) {
  var result = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var group = _step.value;

      if (Array.isArray(group)) {
        for (var i = 0; i < group.length; i++) {
          result = result.concat(getFields(group[i]));
        }
      } else {
        for (var name in group.fields) {
          result.push(name);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};

var getFieldsValue = function getFieldsValue(groups) {
  var result = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = groups[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var group = _step2.value;

      if (Array.isArray(group)) {
        for (var i = 0; i < group.length; i++) {
          result = (0, _util.merge)(result, getFieldsValue(group[i]));
        }
      } else {
        result = (0, _util.merge)(result, group.fields);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return result;
};

var getErrors = function getErrors(fields, values) {
  var errors = {};
  for (var field in fields) {
    var validators = fields[field].validators;
    if (!validators) {
      continue;
    }

    var value = values[field];

    if (validators.required && !value) {
      errors[field] = Required;
    } else if (value && validators.regex && !validators.regex.value.test(value)) {
      errors[field] = validators.regex.message;
    } else if (value && validators.maxLength && validators.minLength && (value.length > validators.maxLength || value.length < validators.minLength)) {
      errors[field] = MaxAndMinLength(validators.maxLength, validators.minLength);
    } else if (value && validators.minLength && value.length < validators.minLength) {
      errors[field] = MinLength(validators.minLength);
    } else if (value && validators.maxLength && value.length > validators.maxLength) {
      errors[field] = MaxLength(validators.maxLength);
    } else if (value && validators.type === 'number' && !_regexp.number.test(value)) {
      errors[field] = NumberExpected;
    } else if (value && validators.max && validators.min && (value > validators.max || value < validators.min)) {
      errors[field] = MaxAndMin(validators.max, validators.min);
    } else if (value && validators.min && value < validators.min) {
      errors[field] = Min(validators.min);
    } else if (value && validators.max && value > validators.max) {
      errors[field] = Max(validators.max);
    }
  }
  return errors;
};

var getValidate = function getValidate(validate, fields) {
  return function (values) {
    var errors = getErrors(fields, values);
    var userErrors = validate ? validate(values) : {};
    return (0, _util.merge)(errors, userErrors);
  };
};

var getAsyncValidate = function getAsyncValidate(validate, fields) {
  var frameworkValidation = getValidate(validate, fields);
  return function (values) {
    return new _bluebird2.default(function (resolve, reject) {
      var errors = frameworkValidation(values);
      if (Object.keys(errors).length === 0 && errors.constructor === Object) {
        resolve();
      } else {
        reject(errors);
      }
    });
  };
};

exports.default = function (_ref) {
  var name = _ref.name,
      groups = _ref.groups,
      validate = _ref.validate,
      readOnly = _ref.readOnly;

  var fields = groups ? getFields(groups) : null;
  return (0, _reduxForm.reduxForm)({
    form: name,
    fields: fields,
    asyncBlurFields: fields,
    asyncValidate: getAsyncValidate(validate, getFieldsValue(groups)),
    readOnly: readOnly || false
  })(_Form2.default);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/FormContainer/FormContainer.js
 ** module id = 169
 ** module chunks = 0
 **/